module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-23GIU-25BLOG-small-7406d0057457babd8c5b5970a9b79b37.jpg";